import { Controller } from "@hotwired/stimulus";
import utils from "@/utils";
import { Vec2 } from "./vec2";

/** 
 * Moves the controller element in response to drag events.
 * Warning: does not preserve existing transforms on the element.
 **/
export default class DraggableController extends Controller<HTMLElement> {

    static targets = ['handle']

    declare readonly hasHandleTarget: boolean;
    declare readonly handleTarget: HTMLElement;

    private translation: Vec2 = new Vec2(0, 0);
    //TODO add tests for connector/clean up page interactions
    // private hasConnector: boolean = false;
    // private anchor: HTMLElement;
    // private connector: HTMLElement;
    // private connectorEvent: any = this.updateConnector.bind(this);

    connect() {
        // For now, the handle is used to drag the element
        if (this.hasHandleTarget) { // Extra check to prevent errors in tests
            utils.addController(this.handleTarget, 'drag-handle');
            utils.addAction(this.handleTarget, 'drag->draggable#handleDragEvent');
        }
        // if('withConnector' in this.element.dataset){
        //     this.hasConnector = true;
        //     this.anchor = document.getElementById(this.element.dataset.withAnchor!)!;
        //     this.connector = document.getElementById(this.element.dataset.withConnector!)!;
        //     window.addEventListener('resize', this.connectorEvent);
        //     window.addEventListener('scroll', this.connectorEvent);
        // }
    }

    disconnect(): void {
        // if('withConnector' in this.element.dataset){
        //     window.removeEventListener('resize', this.connectorEvent);
        //     window.removeEventListener('scroll', this.connectorEvent);
        //     this.translation = new Vec2(0, 0);
        // }
        super.disconnect();
    }

    handleDragEvent(event: CustomEvent<{ pointer: Vec2, delta: Vec2 }>) {
        let { pointer, delta } = event.detail;
        this.drag(pointer, delta);
        // if(this.hasConnector){
        //     this.element.style.transition = 'none';
        // }
    }

    drag(pointer: Vec2, delta: Vec2) {
        this.move(this.adjustForPointerOutsideViewport(pointer, delta));
    }

    private adjustForPointerOutsideViewport(pointer: Vec2, delta: Vec2): Vec2 {
        // Ignore delta.x if pointer.x is outside the viewport
        let viewportWidth = window.innerWidth;
        if (pointer.x < 0 || pointer.x > viewportWidth) {
            delta.x = 0;
        }
        // Ignore delta.y if pointer.y is outside the viewport
        let viewportHeight = window.innerHeight;
        if (pointer.y < 0 || pointer.y > viewportHeight) {
            delta.y = 0;
        }
        return delta;;
    }

    private move(delta: Vec2) {
        // Add to the existing translation
        let {x, y} = this.translation = this.translation.add(delta);
        this.application.logDebugActivity(this.identifier, this.move.name, {translation: this.translation, delta});
        this.element.style.transform = `translate(${x}px, ${y}px)`;
        // if(this.hasConnector){
        //     this.updateConnector();
        // }
    }

    // private updateConnector()
    // {
    //     let anchorRect = this.anchor?.getBoundingClientRect();
    //     let anchorCenterX = anchorRect.left + anchorRect?.width / 2;
    //     let anchorCenterY = anchorRect.top + anchorRect?.height / 2;

    //     let cardRect = this.element.getBoundingClientRect();
    //     let cardCenterX = cardRect.left + cardRect.width / 2;
    //     let cardCenterY = cardRect.top + cardRect.height / 2;

    //     this.connector?.setAttribute('x1', String(anchorCenterX));
    //     this.connector?.setAttribute('y1', String(anchorCenterY));
    //     this.connector?.setAttribute('x2', String(cardCenterX));
    //     this.connector?.setAttribute('y2', String(cardCenterY));
    // }
}
